var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0231934,
    width: 29.1086,
    height: 29.1086,
    rx: 4.5961,
    fill: "url(#paint0_linear_7189_9007)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2649 13.8078L20.2608 13.806L9.25058 9.2393C9.15797 9.20054 9.0572 9.18533 8.95728 9.19505C8.85736 9.20477 8.7614 9.2391 8.678 9.29498C8.58988 9.35272 8.5175 9.43146 8.46737 9.52412C8.41724 9.61678 8.39093 9.72045 8.39081 9.8258V12.7464C8.39086 12.8905 8.44115 13.03 8.53301 13.1409C8.62487 13.2518 8.75255 13.3272 8.89404 13.3541L14.899 14.4644C14.9226 14.4689 14.9439 14.4815 14.9592 14.5C14.9746 14.5185 14.9829 14.5417 14.9829 14.5657C14.9829 14.5898 14.9746 14.613 14.9592 14.6315C14.9439 14.65 14.9226 14.6626 14.899 14.6671L8.8943 15.7774C8.75285 15.8042 8.62517 15.8795 8.53327 15.9904C8.44137 16.1012 8.39099 16.2406 8.39081 16.3845V19.3057C8.39074 19.4063 8.41565 19.5053 8.4633 19.5939C8.51095 19.6825 8.57985 19.7579 8.66382 19.8133C8.76483 19.8804 8.88337 19.9163 9.00464 19.9164C9.08894 19.9164 9.17238 19.8994 9.25006 19.8667L20.26 15.326L20.2649 15.3237C20.4131 15.26 20.5394 15.1543 20.6281 15.0195C20.7169 14.8848 20.7642 14.7271 20.7642 14.5657C20.7642 14.4044 20.7169 14.2467 20.6281 14.112C20.5394 13.9772 20.4131 13.8715 20.2649 13.8078V13.8078Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7189_9007",
    x1: 1.14276,
    y1: 4.85145,
    x2: 29.5883,
    y2: 6.61877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6535E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E33E9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.34912408248ff5457994f8cf67f083d7.svg";
export { ForwardRef as ReactComponent };